const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_chat: 'e904',
  add_reaction: 'e905',
  addboost: 'e906',
  addmember_filled: 'e907',
  adduser: 'e908',
  admin: 'e909',
  ads: 'e90a',
  align_center: 'e90b',
  align_left: 'e90c',
  align_right: 'e90d',
  animals: 'e90e',
  animations: 'e90f',
  app_expand: 'e910',
  app_shrink: 'e911',
  archive: 'e912',
  arrow_down: 'e913',
  arrow_next: 'e914',
  arrow_prev: 'e915',
  arrow_up_circle_fill: 'e916',
  arrowcircle: 'e917',
  arrowhead: 'e918',
  attach: 'e919',
  attach_edit: 'e91a',
  audio_repeat: 'e91b',
  audio_repeat_single: 'e91c',
  author_hidden: 'e91d',
  auto_delete_circle_1: 'e91e',
  auto_delete_circle_2: 'e91f',
  auto_delete_circle_3: 'e920',
  auto_delete_circle_4: 'e921',
  auto_delete_circle_5: 'e922',
  auto_delete_circle_6: 'e923',
  auto_delete_circle_clock: 'e924',
  auto_delete_circle_days: 'e925',
  auto_delete_circle_empty: 'e926',
  auto_delete_circle_months: 'e927',
  auto_delete_circle_off: 'e928',
  auto_delete_circle_weeks: 'e929',
  auto_delete_circle_years: 'e92a',
  avatarnext: 'e92b',
  avatarprevious: 'e92c',
  aversion: 'e92d',
  back: 'e92e',
  binfilled: 'e92f',
  bold: 'e930',
  bomb: 'e931',
  boost: 'e932',
  boostcircle: 'e933',
  bot_filled: 'e934',
  botcom: 'e935',
  bots: 'e936',
  brightness: 'e937',
  brush: 'e938',
  bubblereply: 'e939',
  bug: 'e93a',
  calendar: 'e93b',
  calendarfilter: 'e93c',
  camera: 'e93d',
  cameraadd: 'e93e',
  captiondown: 'e93f',
  captionup: 'e940',
  car: 'e941',
  card: 'e942',
  card_outline: 'e943',
  cash_circle: 'e944',
  channel: 'e945',
  channel_filled: 'e946',
  channelviews: 'e947',
  chatspinned: 'e948',
  chatsplaceholder: 'e949',
  check1: 'e94a',
  checkbox: 'e94b',
  checkboxblock: 'e94c',
  checkboxempty: 'e94d',
  checkboxon: 'e94e',
  checklist_add: 'e94f',
  checklist_done: 'e950',
  checklist_undone: 'e951',
  checkretract: 'e952',
  checkround: 'e953',
  checkround_filled: 'e954',
  clipboard: 'e955',
  clock: 'e956',
  close: 'e957',
  clouddownload: 'e958',
  collapse: 'e959',
  colorize: 'e95a',
  comments: 'e95b',
  commentssticker: 'e95c',
  contrast: 'e95d',
  copy: 'e95e',
  crop: 'e95f',
  cross: 'e960',
  crossgif: 'e961',
  crossround: 'e962',
  crossround_filled: 'e963',
  crossstar: 'e964',
  crown: 'e965',
  crown_outline: 'e966',
  crownalt: 'e967',
  crownoff: 'e968',
  crownoff_outline: 'e969',
  darkmode: 'e96a',
  data: 'e96b',
  delete: 'e96c',
  delete_filled: 'e96d',
  deletedaccount: 'e96e',
  deleteleft: 'e96f',
  deleteuser: 'e970',
  devices: 'e971',
  document: 'e972',
  dollar_circle: 'e973',
  dollar_circle_x: 'e974',
  down: 'e975',
  down_up: 'e976',
  download: 'e977',
  dragfiles: 'e978',
  dragmedia: 'e979',
  eats: 'e97a',
  edit: 'e97b',
  email: 'e97c',
  endcall_filled: 'e97d',
  enhance: 'e97e',
  enter: 'e97f',
  equalizer: 'e980',
  expand: 'e981',
  eye: 'e982',
  eye1: 'e983',
  eye2: 'e984',
  eyecross_outline: 'e985',
  faceid: 'e986',
  factcheck: 'e987',
  fade: 'e988',
  fast_forward: 'e989',
  fast_rewind: 'e98a',
  favourites: 'e98b',
  filter: 'e98c',
  fire: 'e98d',
  flag: 'e98e',
  flip: 'e98f',
  flip_image_horizontal: 'e990',
  folder: 'e991',
  fontframe: 'e992',
  fontframe_bg: 'e993',
  fontframe_outline: 'e994',
  fontsize: 'e995',
  forward: 'e996',
  forward_filled: 'e997',
  free_transform: 'e998',
  fullscreen: 'e999',
  gc_microphone: 'e99a',
  gc_microphoneoff: 'e99b',
  gem: 'e99c',
  gem_exchange: 'e99d',
  gem_transfer: 'e99e',
  gem_transfer_outline: 'e99f',
  geometric_digit_0: 'e9a0',
  geometric_digit_1: 'e9a1',
  geometric_digit_2: 'e9a2',
  geometric_digit_3: 'e9a3',
  geometric_digit_4: 'e9a4',
  geometric_digit_5: 'e9a5',
  geometric_digit_6: 'e9a6',
  geometric_digit_7: 'e9a7',
  geometric_digit_8: 'e9a8',
  geometric_digit_9: 'e9a9',
  geometric_dot: 'e9aa',
  geometric_letter_x: 'e9ab',
  gifs: 'e9ac',
  gift: 'e9ad',
  gift_premium: 'e9ae',
  grain: 'e9af',
  group: 'e9b0',
  group_filled: 'e9b1',
  group_star: 'e9b2',
  groupmedia: 'e9b3',
  groupmediaoff: 'e9b4',
  hand: 'e9b5',
  help: 'e9b6',
  hide: 'e9b7',
  highlights: 'e9b8',
  hourglass: 'e9b9',
  image: 'e9ba',
  image_original: 'e9bb',
  info: 'e9bc',
  info2: 'e9bd',
  italic: 'e9be',
  key: 'e9bf',
  keyboard: 'e9c0',
  lamp: 'e9c1',
  language: 'e9c2',
  largepause: 'e9c3',
  largeplay: 'e9c4',
  left: 'e9c5',
  limit_chat: 'e9c6',
  limit_chats: 'e9c7',
  limit_file: 'e9c8',
  limit_folders: 'e9c9',
  limit_link: 'e9ca',
  limit_pin: 'e9cb',
  link: 'e9cc',
  link_paid: 'e9cd',
  list: 'e9ce',
  listscreenshare: 'e9cf',
  livelocation: 'e9d0',
  location: 'e9d1',
  lock: 'e9d2',
  lockoff: 'e9d3',
  loginlogodesktop: 'e9d4',
  loginlogomobile: 'e9d5',
  logout: 'e9d6',
  mac_command_key: 'e9d7',
  mediaspeed_empty: 'e9d8',
  mediaspoiler: 'e9d9',
  mediaspoileroff: 'e9da',
  mention: 'e9db',
  menu: 'e9dc',
  menu_feature_cover: 'e9dd',
  menu_feature_unique: 'e9de',
  menu_verification: 'e9df',
  message: 'e9e0',
  message_jump: 'e9e1',
  message_quote: 'e9e2',
  messageunread: 'e9e3',
  microphone: 'e9e4',
  microphone_crossed: 'e9e5',
  microphone_crossed_filled: 'e9e6',
  microphone_filled: 'e9e7',
  minus: 'e9e8',
  monospace: 'e9e9',
  more: 'e9ea',
  multistories: 'e9eb',
  mute: 'e9ec',
  muted: 'e9ed',
  mynotes: 'e9ee',
  newchannel: 'e9ef',
  newchannel_filled: 'e9f0',
  newchat_filled: 'e9f1',
  newgroup: 'e9f2',
  newgroup_filled: 'e9f3',
  newprivate: 'e9f4',
  newprivate_filled: 'e9f5',
  newtab: 'e9f6',
  next: 'e9f7',
  nochannel: 'e9f8',
  noncontacts: 'e9f9',
  nosound: 'e9fa',
  okay: 'e9fb',
  online: 'e9fc',
  passwordoff: 'e9fd',
  pause: 'e9fe',
  permissions: 'e9ff',
  person: 'ea00',
  phone: 'ea01',
  phone_filled: 'ea02',
  pin: 'ea03',
  pin2: 'ea04',
  pinlist: 'ea05',
  pinned_filled: 'ea06',
  pinnedchat: 'ea07',
  pip: 'ea08',
  play: 'ea09',
  playback_05: 'ea0a',
  playback_15: 'ea0b',
  playback_1x: 'ea0c',
  playback_2x: 'ea0d',
  plus: 'ea0e',
  plusround: 'ea0f',
  poll: 'ea10',
  premium_addone: 'ea11',
  premium_avatars: 'ea12',
  premium_badge: 'ea13',
  premium_colors: 'ea14',
  premium_double: 'ea15',
  premium_emoji: 'ea16',
  premium_filesize: 'ea17',
  premium_lastseen: 'ea18',
  premium_limits: 'ea19',
  premium_lock: 'ea1a',
  premium_management: 'ea1b',
  premium_noads: 'ea1c',
  premium_privacy: 'ea1d',
  premium_reactions: 'ea1e',
  premium_restrict: 'ea1f',
  premium_speed: 'ea20',
  premium_status: 'ea21',
  premium_stickers: 'ea22',
  premium_tags: 'ea23',
  premium_transcription: 'ea24',
  premium_translate: 'ea25',
  premium_unlock: 'ea26',
  premium_wallpaper: 'ea27',
  previous: 'ea28',
  promote: 'ea29',
  quote: 'ea2a',
  quote_outline: 'ea2b',
  radiooff: 'ea2c',
  radioon: 'ea2d',
  reactions: 'ea2e',
  reactions_filled: 'ea2f',
  readchats: 'ea30',
  recent: 'ea31',
  redo: 'ea32',
  reload_star: 'ea33',
  replace: 'ea34',
  reply: 'ea35',
  reply_filled: 'ea36',
  restrict: 'ea37',
  revenue: 'ea38',
  rightpanel: 'ea39',
  rotate: 'ea3a',
  rotate_left: 'ea3b',
  rotate_right: 'ea3c',
  round_chats_filled: 'ea3d',
  saturation: 'ea3e',
  saved: 'ea3f',
  savedmessages: 'ea40',
  schedule: 'ea41',
  scheduled: 'ea42',
  search: 'ea43',
  select: 'ea44',
  send: 'ea45',
  send2: 'ea46',
  sending: 'ea47',
  sendingerror: 'ea48',
  settings: 'ea49',
  settings_clipped_corner: 'ea4a',
  settings_filled: 'ea4b',
  shadows: 'ea4c',
  sharescreen_filled: 'ea4d',
  sharpen: 'ea4e',
  shipping: 'ea4f',
  shuffle: 'ea50',
  smallscreen: 'ea51',
  smile: 'ea52',
  sort_date: 'ea53',
  sort_num: 'ea54',
  sort_price: 'ea55',
  speaker: 'ea56',
  speakerfilled: 'ea57',
  speakeroff: 'ea58',
  speakerofffilled: 'ea59',
  spoiler: 'ea5a',
  sport: 'ea5b',
  star: 'ea5c',
  star_filled: 'ea5d',
  statistics: 'ea5e',
  stickers: 'ea5f',
  stickers_face: 'ea60',
  stop: 'ea61',
  stories: 'ea62',
  storyreply: 'ea63',
  storyrepost: 'ea64',
  strikethrough: 'ea65',
  suggested: 'ea66',
  tag: 'ea67',
  tag_add: 'ea68',
  tag_alt: 'ea69',
  tag_alt_crossed: 'ea6a',
  tag_alt_outline: 'ea6b',
  tag_crossed: 'ea6c',
  tag_filter: 'ea6d',
  tag_name: 'ea6e',
  text: 'ea6f',
  textedit: 'ea70',
  time_lock: 'ea71',
  timer: 'ea72',
  tip: 'ea73',
  ton: 'ea74',
  tools: 'ea75',
  topics: 'ea76',
  trade: 'ea77',
  transcribe: 'ea78',
  unarchive: 'ea79',
  unclaimed: 'ea7a',
  underline: 'ea7b',
  undo: 'ea7c',
  unmute: 'ea7d',
  unpack: 'ea7e',
  unpin: 'ea7f',
  unread: 'ea80',
  up: 'ea81',
  up_down: 'ea82',
  user: 'ea83',
  username: 'ea84',
  videocamera: 'ea85',
  videocamera_crossed_filled: 'ea86',
  videocamera_filled: 'ea87',
  videochat: 'ea88',
  vignette: 'ea89',
  volume_down: 'ea8a',
  volume_mute: 'ea8b',
  volume_off: 'ea8c',
  volume_up: 'ea8d',
  warmth: 'ea8e',
  warning: 'ea8f',
  webview: 'ea90',
  win_key: 'ea91',
  zoomin: 'ea92',
  zoomout: 'ea93'
};

export default Icons;
